import React, { useState } from 'react'
import { CAlert, CButton, CForm, CFormInput, CFormLabel, CSpinner } from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { icon } from '../../shared/icons'
import { request } from '../../services'

function Login({ onLoggedIn, env }) {
  const [step, setStep] = useState('credentials')
  const [form, setForm] = useState({ email: '', password: '', code: '' })
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const environmentLabel = env === 'STG' ? 'Staging' : 'Producción'

  function update(name, value) {
    setForm((current) => ({ ...current, [name]: value }))
  }

  async function submit(event) {
    event.preventDefault()
    setError('')
    setLoading(true)
    const action = step === 'credentials' ? 'login' : 'login_verify'
    const body = step === 'credentials'
      ? { email: form.email, password: form.password }
      : { code: form.code }
    const res = await request(action, { method: 'POST', body })
    setLoading(false)
    if (!res.ok) {
      setError(res.data?.error || Object.values(res.data?.errors || {})[0] || 'No se pudo iniciar sesion')
      return
    }
    if (res.data.requires_2fa) {
      setStep('verify')
      return
    }
    onLoggedIn()
  }

  return (
    <main className="login-screen">
      <div className="login-icon">
        <CIcon icon={icon('cilShieldAlt')} />
      </div>
      <h1>Boston Scripts</h1>
      <p>Administrador de agencias</p>
      <div className="env-indicator">
        <span>{environmentLabel}</span>
      </div>
      {error ? <CAlert color="danger">{error}</CAlert> : null}
      <CForm onSubmit={submit}>
        {step === 'credentials' ? (
          <>
            <div className="mb-3">
              <CFormLabel>Email</CFormLabel>
              <CFormInput type="email" value={form.email} onChange={(event) => update('email', event.target.value)} required />
            </div>
            <div className="mb-3">
              <CFormLabel>Contrasena</CFormLabel>
              <CFormInput type="password" value={form.password} onChange={(event) => update('password', event.target.value)} required />
            </div>
          </>
        ) : (
          <div className="mb-3">
            <CFormLabel>Codigo 2FA</CFormLabel>
            <CFormInput value={form.code} maxLength={6} inputMode="numeric" onChange={(event) => update('code', event.target.value.replace(/\D/g, ''))} required />
          </div>
        )}
        <CButton color="success" className="w-100 btn-brand" type="submit" disabled={loading}>
          {loading ? <CSpinner size="sm" /> : <CIcon icon={icon('cilLockLocked')} />} {step === 'credentials' ? 'Continuar' : 'Verificar'}
        </CButton>
      </CForm>
    </main>
  )
}

export default Login
